import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-drivers-programacion-listar',
  templateUrl: './drivers-programacion-listar.component.html',
  styleUrls: ['./drivers-programacion-listar.component.scss']
})
export class DriversProgramacionListarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
